/*
  Kinaï : apparition au défilement.
  Les éléments en bas de l'écran sont un peu transparents et légèrement décalés,
  puis deviennent complètement opaques à mesure qu'ils montent dans l'écran.
  Désactivé si la personne a demandé moins d'animations (réglage du téléphone / ordinateur).
*/
(function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.Shopify && window.Shopify.designMode) return; // pas dans l'éditeur de thème

  var SEL = [
    '.kinai-home .k-sec-head',
    '.kinai-home .k-grid > *',
    '.kinai-home .k-uni > *',
    '.kinai-home .k-emb__tx',
    '.kinai-home .k-studio',
    '.kinai-home .k-more',
    '.kinai-band .k-band__in > h2',
    '.kinai-band .k-rev-head',
    '.kinai-band .k-revs',
    '.kinai-band .k-feat',
    '.kinai-band .k-faq-head',
    '.kinai-band details',
    '.kinai-band .k-more > a',
    '.kinai-band .k-jm-write',
    '.kinai-plp .k-grid > .k-card',
    '.kinai-plp .k-tile',
    '.kinai-plp .k-about',
    '.k-steps2 .k-st',
    '.k-steps2 .k-steps2__head',
    '.k-story__photo',
    '.k-story__card',
    '.kinai-foot .kf-news__in',
    '.kinai-foot .kf-main > *'
  ].join(',');

  var els = [];
  var ticking = false;

  function collect() {
    document.querySelectorAll(SEL).forEach(function (el) {
      if (el.dataset.kRv) return;
      el.dataset.kRv = '1';
      el.classList.add('k-rv');
      els.push(el);
    });
  }

  function frame() {
    ticking = false;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var zone = vh * 0.3; // hauteur de la zone de « montée » en bas de l'écran
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var r = el.getBoundingClientRect();
      var p;
      if (r.top >= vh) p = 0;
      else if (r.top <= vh - zone || r.bottom <= 0) p = 1;
      else p = (vh - r.top) / zone;
      p = Math.max(0, Math.min(1, p));
      var prev = el._kRv;
      if (prev === undefined || Math.abs(prev - p) > 0.01) {
        el._kRv = p;
        el.style.setProperty('--k-rv', p.toFixed(3));
      }
    }
  }
  function request() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(frame);
  }

  function start() {
    collect();
    frame();
    window.addEventListener('scroll', request, { passive: true });
    window.addEventListener('resize', request);
    // Contenus ajoutés plus tard (« Voir plus », avis…)
    if (window.MutationObserver) {
      var pending = false;
      new MutationObserver(function () {
        if (pending) return;
        pending = true;
        setTimeout(function () { pending = false; collect(); request(); }, 200);
      }).observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
